import { GasStationClient, GasStationTransactionSubmitter } from "@aptos-labs/gas-station-client";
import { Account, Ed25519PrivateKey } from "@aptos-labs/ts-sdk";

import { aptosConfig } from "../api/aptos/aptos";

let gasStationClient: GasStationClient | null = null;
let transactionSubmitter: GasStationTransactionSubmitter | null = null;
let sponsorAccount: Account | null = null;

export const initializeGasStation = (apiKey: string) => {
  gasStationClient = new GasStationClient({
    network: aptosConfig.network,
    apiKey,
  });
  transactionSubmitter = new GasStationTransactionSubmitter(gasStationClient);

  const sponsorPrivateKey = import.meta.env.VITE_SPONSOR_PRIVATE_KEY;
  if (sponsorPrivateKey) {
    const privateKey = new Ed25519PrivateKey(sponsorPrivateKey);
    sponsorAccount = Account.fromPrivateKey({ privateKey });
  } else {
    sponsorAccount = Account.generate();
  }
};

export const getTransactionSubmitter = (): GasStationTransactionSubmitter | null => {
  return transactionSubmitter;
};

export const getSponsorAccount = (): Account | null => {
  return sponsorAccount;
};

export const isGasStationInitialized = (): boolean => {
  return transactionSubmitter !== null;
};
